'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ButtonStyle = require('./ButtonStyle.scss');

var _ButtonStyle2 = _interopRequireDefault(_ButtonStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_dec = (0, _reactCssModules2.default)(_ButtonStyle2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Button, _React$Component);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);
    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
  }

  (0, _createClass3.default)(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inline = _props.inline,
          weight = _props.weight,
          buttonProps = (0, _objectWithoutProperties3.default)(_props, ['inline', 'weight']);

      delete buttonProps.styles;
      var style = inline ? 'a-button--inline' : 'a-button';

      return _react2.default.createElement('button', (0, _extends3.default)({ styleName: style + ' a-button--' + weight }, buttonProps));
    }
  }]);
  return Button;
}(_react2.default.Component), _class2.propTypes = {
  inline: _react.PropTypes.bool,
  type: _react.PropTypes.string
}, _class2.defaultProps = {
  inline: false,
  type: 'submit',
  weight: 'primary'
}, _temp)) || _class);
exports.default = Button;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/Button.js
// module id = 585
// module chunks = 0